module.exports = __webpack_public_path__ + "static/media/win-reward-A02.165b26f4.png";